import { get } from 'lodash';
import { OptionsType, OptionType } from '@lendi-ui/dropdown';

import { FIELD_PATHS } from '@funnels/constants';
import { StoreApplicant } from '@funnels/types';

function createNumberOption(index: number, valuesAsNumbers: boolean) {
  if (valuesAsNumbers) {
    return { label: `${index}`, value: index };
  } else {
    return { label: `${index}`, value: `${index}` };
  }
}

export function generateNumberOptions(
  from: number,
  to: number,
  valuesAsNumbers: boolean = false
): OptionsType<OptionType> {
  const length = Math.abs(to - from) + 1;

  // Ascending
  if (from < to) {
    return [...new Array(length)].map((__, i) => {
      const index = from + i;
      return createNumberOption(index, valuesAsNumbers);
    });
    // Descending
  } else if (to < from) {
    return [...new Array(length)].map((__, i) => {
      const index = from - i;
      return createNumberOption(index, valuesAsNumbers);
    });
  }

  // From === to, return one option
  return [createNumberOption(from, valuesAsNumbers)];
}

export function generateDependantSharedWithOptions(
  applicants: StoreApplicant[],
  currentApplicantIndex: number
): OptionsType<OptionType> {
  return [
    ...applicants
      .filter((__, i) => i !== currentApplicantIndex)
      // consider logged in applicant as applicant 1, index starting from 2 onwards
      .map((applicant, i) => {
        const firstName = `${get({ applicants: [applicant] }, FIELD_PATHS.APPLICANT_FIRST_NAME(0))}`;
        const lastName = `${(get({ applicants: [applicant] }, FIELD_PATHS.APPLICANT_LAST_NAME(0)), '')}`;
        const fullName = !firstName ? `Applicant ${i + 2}` : `${firstName} ${lastName}`;
        return {
          label: fullName,
          value: `${applicant.clientId}`,
        };
      }),
    { label: 'Non-applicant', value: '' },
  ];
}
